interface IMinInfo {
  number?: string | number;
  externalCredentialNumber?: string | number;
}

export const passCredOrNumber = <T extends IMinInfo>(pass?: T): string =>
  String(pass?.externalCredentialNumber || pass?.number || '');
